<template>
  <div class="wap">
    <div class="top1_2">
      <div class="bg_box1">
        <img class="bg_img" src="../assets/mobile/top_bg.jpg" alt="" srcset="" />
        <div class="bg_kuang1">玩家不歇</div>
        <div class="bg_kuang2">盈利不止</div>
      </div>
      <div class="bg_box2">
        <span class="text1">冰火游戏手游创业平台</span>
        <span class="text2">唯一一家自运营过亿流水手游平台孵化</span>
        <div class="plat_type">
          <div class="type_item" v-for="(v, k) in types" :key="k">{{ v }}</div>
        </div>
      </div>
      <div class="top_box3">
        <div class="bo3_title">一级代理</div>
        <div class="box3_desc">无中间商赚差价 直接对接平台</div>
        <el-image style="width: 100%;" src="https://jmy-pic.baidu.com/0/pic/2029648746_-768718088_-1482771772.png"
          fit="fill" />
        <div class="bo3_title">专业团队</div>
        <div class="box3_desc" style="font-size: 21px">
          自运营冰火游戏手游平台 过亿流水
        </div>
        <!-- workList -->
        <div class="carousel_box">
          <swiper :effect="'cards'" :grabCursor="true" :loop="true" :modules="[EffectCards,Pagination,Autoplay]"
            :pagination="true" :autoplay="{ delay: 3000, disableOnInteraction: false }" class="mySwiper">
            <swiper-slide class="slide-box" v-for="(item, k) in workList" :key="k">
              <el-image :src="item" class="lun_imgw" fit="fill" :preview-teleported="true" :preview-src-list="workList"
                :initial-index="k" />
            </swiper-slide>
          </swiper>
        </div>
        <div class="bo3_title">轻松推广</div>
        <div class="box3_desc">一键推广市场热门千款手游 无忧对接</div>
        <div class="carousel_box">
          <el-carousel :interval="4000" indicator-position="none" type="card" height="2rem">
            <el-carousel-item v-for="(item, k) in 4" :key="k">
              <el-image class="lun_img" :src="require('/src/assets/mobile/promote_img'+k+'.webp')" fit="fill" />
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="now_here">
          <img class="here_peo" src="../assets/mobile/people.png" alt="" srcset="" />
          <div class="text_box">
            <div class="text1">移动互联手游春天</div>
            <div class="text2">手游玩家无处不在</div>
          </div>
        </div>
        <div class="big_box">
          <div class="big_item" v-for="(v, k) in bigList" :key="k">
            <div class="big_img">
              {{ v.word }}
            </div>
            <div class="right_word">
              <div class="right_title1">{{ v.title1 }}</div>
              <div class="right_title2">{{ v.title2 }}</div>
            </div>
          </div>
        </div>
        <div class="title_w">手把手培训上线运营</div>
        <div class="title_y">重游戏更重实践操作</div>
        <div class="help_box">
          <div class="help_item" v-for="(v, k) in helpList" :key="k">
            <img class="help_img" :src="v.img" alt="" srcset="" />
            <div class="help_name">{{ v.name }}</div>
            <div class="help_desc">{{ v.desc }}</div>
          </div>
        </div>
        <div class="title_yi">【资质&产品】</div>
        <div class="title_ji">百万级玩家 20000+日活 背靠大树好乘凉</div>
        <div class="carousel_box">
          <!-- <el-carousel :interval="4000" arrow="always" :autoplay="true" indicator-position="none" type="card"
            height="328px">
            <el-carousel-item v-for="(item, k) in productList" :key="k">
              <el-image class="lun_img2" :src="item" fit="fill" />
            </el-carousel-item>
          </el-carousel> -->
          <!-- @tap="prevCompany" -->
          <swiper class="swiper_box3" :effect="'flip'" :grabCursor="true" :pagination="true"
            :autoplay="{ delay: 3000, disableOnInteraction: false }" :modules="[EffectFlip, Pagination,Autoplay]">
            <swiper-slide class="slide-box" v-for="(item, k) in productList" :key="k">
              <el-image class="lun_img2" :src="item" fit="fill" :preview-teleported="true"
                :preview-src-list="productList" :initial-index="k" />
            </swiper-slide>
          </swiper>
        </div>
        <div class="sub_title">一站式游戏创业好项目</div>
        <div class="sub_title" style="color: #fff316;">技术运营一体化服务商</div>
        <div class="sub_title2">游戏研发 游戏运营 0基础 玩转游戏产业</div>
        <div class="form_box">
          <div class="form_title">立即咨询获取游戏项目详情</div>
          <el-form ref="ruleFormRef" :model="ruleForm" :rules="rules" label-width="auto" class="rule_form" status-icon>
            <el-form-item label="姓名" prop="name">
              <el-input v-model="ruleForm.name" />
            </el-form-item>
            <el-form-item label="手机" prop="phone">
              <el-input v-model="ruleForm.phone" />
            </el-form-item>
            <el-form-item label="微信" prop="wx">
              <el-input v-model="ruleForm.wx" />
            </el-form-item>
          </el-form>
          <div class="sub_btn" @click="submit(ruleFormRef)" data-agl-cvt='5'>
            立即提交
            <div class="light_move"></div>
          </div>
        </div>
        <div class="bot_join">诚邀您的加入，共创美好明天！</div>
        <div class="company_info">
          Copyright © 2021 湖北冰火网络科技有限公司 版权所有
        </div>
        <div class="company_info">地址：湖北省武汉市洪山区光谷鼎创国际4栋14楼【冰火游戏】</div>
      </div>
    </div>
    <div style="height: 1rem;"></div>
    <div class="chat_box">
      <div class="log_box">
        <el-image class="chat_logo" :src="require('@/assets/logo.png')" fit="fill" />
        <div class="ani_cil"></div>
        <div class="ani_cil2"></div>
      </div>
      <div class="right_chat">
        <div class="chat_con">
          <div class="title1">专业运营为您解答</div>
          <div class="title2">游戏联运/游戏定制开发</div>
        </div>
        <div class="chat_btn" @click="nowChat">立即咨询</div>
      </div>
    </div>

  </div>
</template>
<script setup>
  import {
    reactive,
    ref,
    onMounted,
    getCurrentInstance,
    h
  } from "vue";
  import {
    ElMessage,
    ElMessageBox,
    Action
  } from 'element-plus'
  import {
    CircleClose
  } from '@element-plus/icons-vue'
  import {
    Swiper,
    SwiperSlide
  } from 'swiper/vue';
  import 'swiper/less';
  import 'swiper/css/effect-cards';
  import "swiper/swiper-bundle.css";
  import 'swiper/css/effect-coverflow';
  import 'swiper/css/pagination' // 轮播图底面的小圆点
  import 'swiper/css/navigation' // 轮播图两边的左右箭头
  import {
    Autoplay,
    Pagination,
    Navigation,
    EffectCube,
    EffectFlip,
    EffectCards
  } from 'swiper/modules'
  const navigation = ref({
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  });
  const {
    proxy
  } = getCurrentInstance();
  const instance = getCurrentInstance();
  const types = reactive([
    "千款\n游戏",
    "运营\n推广",
    "高额\n分成",
    "公司\n扶持",
  ]);
  onMounted(() => {

  })

  const wx = ref('tangmubai')
  const nowChat = () => {
    // window.location.href = "weixin://";
    // ElMessageBox.alert(wx.value, '添加微信', {
    //   confirmButtonText: '复制微信',
    //   callback: (action) => {
    //     if (action == 'confirm') {
    //       let input = document.createElement("input");
    //       input.value = wx.value;
    //       document.body.appendChild(input);
    //       input.select();
    //       document.execCommand("Copy");
    //       document.body.removeChild(input)
    //       ElMessage.success('复制成功')
    //     }
    //     console.log(action)
    //   },
    // })
    ElMessageBox({
      title: '添加微信',
      confirmButtonClass: 'confirm_btn',
      message: h('p', null, [
        h('div', {
          style: 'color: teal;font-size:.6rem;'
        }, wx.value),
      ]),
      confirmButtonText: '复制微信',
      callback: (action) => {
        if (action == 'confirm') {
          let input = document.createElement("input");
          input.value = wx.value;
          document.body.appendChild(input);
          input.select();
          document.execCommand("Copy");
          document.body.removeChild(input)
          ElMessage.success('复制成功')
          window._agl && window._agl.push(['track', ['success', {
            t: 35
          }]])
        }

      },
    })
    setTimeout(() => {
      let btn = document.querySelector('.confirm_btn');
      btn.setAttribute("data-agl-cvt", '35');
    }, 500)

  }
  const bigList = reactive([{
      word: "潜",
      title1: "游戏推广潜力巨大",
      title2: "手游市场同比去年大幅增长，移动互联网创业风口",
    },
    {
      word: "力",
      title1: "手游移动端用户占比增加",
      title2: "付费玩家日益增多，互联网轻松加盟创业",
    },
    {
      word: "大",
      title1: "手游市场前景广阔",
      title2: "手游市场回暖，买量进化，玩法升级，等您加入！",
    },
  ]);
  const helpList = reactive([{
      name: "一对一单独培训",
      desc: "培训期间，公司会针对每一个合作商的自身情况安排合适的培训人员。",
      img: 'https://bhres.39bh.com/cpplatform/game/2/20240316/8c4bb1152594d0ffc70c6c97d2f7b7d3.jpg'
    },
    {
      name: "实操理论培训",
      desc: "客户无需担心学不会，不懂等问题，现场实操教您发掘精准玩家群体。",
      img: 'https://bhres.39bh.com/cpplatform/game/264/20240424/f8c023e3e3623b3dd01ea6f4cd82256c.jpg'
    },
    {
      name: "多对一后期维护",
      desc: "公司运营团队群内对接，根据后续合作商推广中遇到的问题逐一解答，逐个击破。",
      img: 'https://bhres.39bh.com/cpplatform/game/123/20240424/d335db33e3c3e465ec816d8d0badb9a0.jpg'
    },
    {
      name: "专业运营深入指导",
      desc: "运营团队经过多年积累，拥有丰富运营经验，教您找到精准玩家。",
      img: 'https://bhres.39bh.com/cpplatform/game/169/20240415/d0d65f2af0c1aaed5d275918021bf38b.jpg'
    },
  ]);
  const swiperList = reactive([
    'https://bhres.39bh.com/cpplatform/game/248/20240321/d2f8e9fb743254f86de658c39ec38f0b.jpg',
    'https://bhres.39bh.com/cpplatform/game/85/20240415/c0345024165ccce187cacdf738fb4326.jpg',
    'https://bhres.39bh.com/cpplatform/game/346/20240402/1d46ab6c8da31d90a03dde5ffa1d8e10.jpg',
    'https://bhres.39bh.com/cpplatform/game/85/20240314/e34528ed503ef4dd34ad3883e04b9c54.jpg'
  ])
  const productList = reactive([
    require('@/assets/mobile/product1.jpg'),
    require('@/assets/mobile/product2.png'),
    require('@/assets/mobile/product3.png'),
    require('@/assets/mobile/product4.png'),
    require('@/assets/mobile/product5.png'),
    require('@/assets/mobile/product6.jpg'),
    require('@/assets/mobile/product7.jpg'),
    require('@/assets/mobile/product8.jpg'),
    require('@/assets/mobile/product9.jpg'),
    require('@/assets/mobile/product10.jpg'),
  ])
  const workList = reactive([
    require('@/assets/mobile/work1.jpg'),
    require('@/assets/mobile/work2.jpg'),
    require('@/assets/mobile/work3.jpeg'),
    require('@/assets/mobile/work4.jpg'),
  ])
  const ruleForm = reactive({
    name: '',
    phone: '',
    wx: '',
  })
  const regex = /^1[3456789]\d{9}$/;
  const checkPhone = (rule, value, callback) => {
    if (!value) {
      return callback(new Error('请输入手机号'))
    } else if (!regex.test(value)) {
      return callback(new Error('手机号格式错误'))
    } else {
      callback()
    }
  }
  const rules = reactive({
    name: [{
        required: true,
        message: '请输入您的名字',
        trigger: 'blur'
      },
      {
        min: 2,
        max: 5,
        message: '长度2到5个',
        trigger: 'blur'
      },
    ],
    phone: [{
      validator: checkPhone,
      required: true,
      trigger: 'blur'
    }],
  })
  const ruleFormRef = ref()
  const submit = (formEl) => {
    if (!formEl) return
    formEl.validate((valid) => {
      if (valid) {
        let parmas = {
          name: ruleForm.name,
          phone: ruleForm.phone,
          wechat: ruleForm.wx
        }
        fetch('https://www.39bh.com/api/game/franchise_info_submit', {
          method: 'post',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(parmas)
        }).then(data => {
          return data.text();
        }).then(ret => {
          let res = JSON.parse(ret)
          if (res.code == 200) {
            window._agl && window._agl.push(['track', ['success', {
              t: 5
            }]])
            ElMessage.success(res.msg || '提交成功')
            if (!formEl) return
            formEl.resetFields()
          } else {
            ElMessage.error(res.msg || '服务端异常')
          }
        });
      } else {
        return false
      }
    })

  };
</script>
<style lang="less" scoped>
  .wap {
    max-width: 500px;
    overflow: hidden;
    position: relative;
  }

  .top1_2 {
    background-color: rgb(25, 38, 72);
  }

  .bg_box1 {
    position: relative;
    color: white;
    font-size: 0;

    .bg_kuang1 {
      position: absolute;
      right: 5vw;
      top: 30px;
      width: 142px;
      height: 42px;
      background-image: url("../assets/mobile/kuang.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      text-align: center;
      line-height: 42px;
      z-index: 10;
      font-size: 21px;
    }

    .bg_kuang2 {
      position: absolute;
      right: 5vw;
      top: 90px;
      width: 142px;
      height: 42px;
      background-image: url("../assets/mobile/kuang.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      text-align: center;
      line-height: 42px;
      z-index: 10;
      font-size: 21px;
    }
  }

  .bg_box2 {
    background-image: url("../assets/mobile/top2_bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 100%;
    max-width: 500px;
    height: 270px;
    position: relative;
    z-index: 111;
    margin-top: -30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .text1 {
      font-size: 23px;
      color: #1abc9c;
      font-weight: bolder;
      vertical-align: bottom;
    }

    .text2 {
      font-size: 18px;
      color: #28324e;
      margin-bottom: 5px;
    }

    .plat_type {
      display: flex;
      margin-bottom: 10px;
      justify-content: space-between;
      width: 80%;
      // margin-left: 5%;

      .type_item {
        background-image: url("../assets/mobile/round.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        width: 1.3rem;
        height: 1.3rem;
        // max-width: 90px;
        // max-height: 90px;
        flex-shrink: 0;
        // margin-right: 10px;
        color: white;
        text-align: center;
        white-space: pre-wrap;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: .3rem;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  .top_box3 {
    background: #4da485;
    display: flex;
    flex-direction: column;
    align-items: center;

    .bo3_title {
      background-image: url("../assets/mobile/kuang.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 213px;
      height: 63px;
      text-align: center;
      line-height: 63px;
      color: white;
      font-size: 30px;
      margin-top: 10px;
    }

    .work_img {
      width: 90%;
      border-radius: .3rem;
      margin: .3rem auto 0;
      // margin-top: .3rem;
    }

    .box3_desc {
      font-size: 21px;
      color: #fff316;
      margin-top: 5px;
      font-weight: bolder;
    }

    .bg3_img {
      width: 100%;
      margin-top: 10px;
    }

    .carousel_box {
      width: 100%;
      margin-top: 20px;

      .lun_img {
        height: 2rem;
        width: 100%;
        border-radius: .2rem;
      }

      .lun_imgw {
        width: 90%;
        border-radius: .5rem;
      }

      .lun_img2 {
        height: 428px;
        width: 80%;
        border-radius: .2rem;
        // max-width: 100%;
        // display: block;

      }
    }

    .now_here {
      margin-top: 15px;
      display: flex;
      overflow: hidden;
      width: 100%;
      position: relative;
      height: 160px;

      .here_peo {
        width: 160px;
        height: 160px;
        left: -20px;
        position: absolute;
      }

      .text_box {
        margin-left: 125px;

        .text1 {
          color: white;
          font-size: 28px;
          margin-top: 30px;
          height: 28px;
        }

        .text2 {
          font-size: 27px;
          color: #fff316;
          height: 28px;
          margin-top: 5px;
        }
      }
    }

    .big_box {
      background: white;
      width: calc(100% - 40px);
      border-radius: 7px;
      padding: 0 10px 15px;
      box-sizing: border-box;
      margin-top: -30px;
      position: relative;
      z-index: 10;

      .big_item {
        display: flex;
        margin-top: 15px;

        .big_img {
          background-image: url("../assets/mobile/round.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          width: 1.3rem;
          height: 1.3rem;
          color: white;
          font-size: .5rem;
          line-height: 1.3rem;
          font-weight: bolder;
          text-align: center;
          flex-shrink: 0;
        }

        .right_word {
          margin-left: 5px;
          font-weight: bolder;
          display: flex;
          flex-direction: column;
          justify-content: center;

          .right_title1 {
            font-size: .42rem;
            color: #28324e;
          }

          .right_title2 {
            font-size: .32rem;
            color: #475577;
          }
        }
      }
    }

    .title_w {
      color: white;
      font-size: 31px;
      margin-top: 20px;
      height: 35px;
    }

    .title_y {
      color: #fff316;
      font-size: 31px;
      height: 35px;
    }

    .help_box {
      display: flex;
      width: calc(100% - 40px);
      flex-wrap: wrap;

      .help_item {
        width: 48%;
        margin-right: 4%;
        margin-top: 30px;

        &:nth-child(2n) {
          margin-right: 0;
        }

        .help_img {
          width: 100%;
          height: 125px;
          display: block;
        }

        .help_name {
          height: 39px;
          background: white;
          color: #1abc9c;
          font-size: 18px;
          text-align: center;
          line-height: 39px;
          font-weight: bolder;
        }

        .help_desc {
          margin-top: 10px;
          color: white;
          font-size: 13px;
        }
      }
    }

    .title_yi {
      font-size: 22px;
      color: white;
      height: 25px;
      margin-top: 30px;
    }

    .title_ji {
      font-size: 18px;
      color: #fff316;
      margin-top: 5px;
    }


    .bot_join {
      color: white;
      line-height: 60px;
      font-size: .5rem;
    }
  }

  .bg_img {
    width: 100%;
  }

  .el-select {
    width: 100%;
  }

  .company_info {
    font-size: .26rem;
    color: #fff;
    text-align: center;
    margin-top: 10px;

    &:last-child {
      margin-bottom: 20px;
    }
  }

  .chat_box {
    position: fixed;
    z-index: 99;
    width: 100%;
    max-width: 500px;
    height: 1rem;
    display: flex;
    align-items: center;
    padding: 0 .2rem;
    box-sizing: border-box;
    box-shadow: 0 -0.18870773rem 0.37741546rem 0 rgba(0, 0, 0, 0.06);
    background-color: #fff;
    bottom: 0;
    margin: 0 auto;
    // left: 50%;
    // transform: translateX(-50%);

    .right_chat {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex: 1;
    }

    .log_box {
      position: relative;
      z-index: 10;
      width: .7rem;
      height: .7rem;
      display: flex;
      align-items: center;
      justify-content: center;

      .chat_logo {
        width: .7rem;
        height: .7rem;
        position: relative;
      }

      .ani_cil {
        position: absolute;
        z-index: 100;
        display: block;
        width: .7rem;
        height: .7rem;
        border: 1px dashed #ff9797;
        box-sizing: border-box;
        transform: scale(0.9);
        border-radius: 50%;
        animation: play 1.6s both infinite;
      }

      .ani_cil2 {
        position: absolute;
        z-index: 100;
        display: block;
        width: .5rem;
        height: .5rem;
        border: 1px solid #018fff;
        box-sizing: border-box;
        transform: scale(0.9);
        border-radius: 50%;
        animation: play 1.6s both infinite;
      }

      @keyframes play {
        0% {
          opacity: 1;
          transform: scale(0.9);
        }

        100% {
          opacity: 0;
          transform: scale(1.3);
        }
      }
    }





    .chat_con {
      font-size: .25rem;
      margin-left: .2rem;

      .title1 {
        color: #858585;
      }

      .title2 {
        color: #1e90ff;
      }
    }

    .chat_btn {
      font-size: .3rem;
      background-image: -webkit-linear-gradient(45deg, #ff9797, #1e90ff);
      color: white;
      text-align: center;
      width: 2rem;
      height: .7rem;
      border-radius: .7rem;
      line-height: .7rem;
    }
  }

  .slide-box {
    text-align: center;
  }

  .sub_title {
    font-size: .5rem;
    font-weight: bolder;
    text-align: center;
    color: #fff;
  }

  .sub_title2 {
    height: .8rem;
    border-radius: .8rem;
    font-size: .35rem;
    text-align: center;
    line-height: .8rem;
    background-color: #fff316;
    margin-top: .2rem;
    padding: 0 .3rem;
  }

  .form_box {
    padding: .3rem .2rem;
    background-color: #fff;
    border-radius: .3rem;
    margin-top: .3rem;
    width: 90%;
    display: flex;
    flex-direction: column;

    .form_title {
      font-size: .4rem;
      font-weight: bolder;
      text-align: center;
    }

    .sub_btn {
      width: 90%;
      height: .85rem;
      line-height: .85rem;
      background-image: -webkit-linear-gradient(45deg, #ff9797, #1e90ff);
      color: white;
      text-align: center;
      border-radius: .65rem;
      font-size: .4rem;
      font-weight: bolder;
      animation: smalltobig 3s infinite;
      align-self: center;
      position: relative;
      overflow: hidden;

      .light_move {
        position: absolute;
        top: 0;
        width: 3rem;
        height: 1.5rem;
        background-image: url('/src/assets/mobile/light_animate.png');
        background-size: 3rem 1.5rem;
        -webkit-animation: aniline 3s linear infinite forwards;
        -o-animation: aniline 3s linear infinite forwards;
        animation: aniline 3s linear infinite forwards;
        -webkit-transform-style: preserve-3d;
        -webkit-backface-visibility: hidden;
        -webkit-perspective: 1000;
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
      }

      @keyframes aniline {
        0% {
          transform: translate(-4rem);
          opacity: 0;
        }

        66% {
          transform: translate(-4rem);
          opacity: 1;
        }

        100% {
          transform: translate(7rem);
        }
      }
    }

    @keyframes smalltobig {
      0% {
        transform: scale(1);
      }

      33% {
        transform: scale(0.95);
      }

      66% {
        transform: scale(1);
      }

      100% {
        transform: scale(1);
      }
    }
  }

  .rule_form {
    margin-top: .3rem;
  }
</style>
